module.exports = __webpack_public_path__ + "static/media/sc-logo-icon.04a56cd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sc-logo-icon.png
// module id = 716
// module chunks = 21